const canSetGa = () => {
  if (typeof window === 'undefined') return false;
  return !!window.gtag;
};

export const setGa4UserId = (uid) => {
  if (canSetGa() && uid) {
    window.gtag('set', { user_id: uid });
  }
};

export const clearGa4UserId = () => {
  if (canSetGa()) {
    window.gtag('set', { user_id: null });
  }
};
